/* 场馆信息相关接口 */
import path from '@/api/index'
import {
    axios
} from '@/utils/request'
import parsePageParams from '@/utils/page'

// 分页
export function queryList(data) {
    return axios({
        url: path.mobile + '/venueInfo',
        method: 'POST',
        data: data,
        params: parsePageParams(data)
    })
}

// 获取详情
export function get(id) {
    return axios({
        url: path.mobile + '/venueInfo/id/' + id,
        method: 'GET'
    })
}

// 获取详情
export function getDetailBySetting() {
    return axios({
        url: path.mobile + '/venueInfo/getDetailBySetting' ,
        method: 'GET'
    })
}

// 获取详情
export function reserveInfo(data) {
    return axios({
        url: path.mobile + '/venueInfo/reserveInfo',
        method: 'POST',
        data: data,
    })
}

// 提交
export function submit(data) {
    return axios({
        url: path.mobile + '/venueInfo/submit',
        method: 'POST',
        data: data,
    })
}

// 提交
export function submitPc(data) {
    return axios({
        url: path.mobile + '/venueInfo/submitPc',
        method: 'POST',
        data: data,
    })
}

// 获取场馆分类下拉数据
export function getVenueClassOptions() {
    return axios({
        url: path.mobile + '/venueInfo/getVenueClassOptions',
        method: 'GET'
    })
}

// 获取场馆分类滑动
export function getSlideOptions() {
    return axios({
        url: path.mobile + '/venueInfo/getSlideOptions',
        method: 'GET'
    })
}

export function getSettingByKey(data) {
    return axios({
        url: path.mobile + '/venueInfo/getSetingByKey',
        method: 'GET',
        params: data
    })
}
